<template>
  <div>
    <div v-if="loading" class="dw-loading">
      <b-spinner small></b-spinner> Loading...
    </div>
    <div v-else-if="!totals || !totals.sms_cnt" class="dw-empty">No SMS sent yet this period.</div>
    <div v-else class="dw-stat-grid">
      <div class="dw-stat-tile">
        <div class="dw-stat-tile-label">Sent Count</div>
        <div class="dw-stat-tile-value">
          {{ totals.sms_cnt }}
          <small>({{ (totals.sms_cnt / totals.alert_cnt) | roundNumber(1) }} #s/msg)</small>
        </div>
      </div>
      <div v-if="totals.sms_cost > 0" class="dw-stat-tile">
        <div class="dw-stat-tile-label">Sent Units</div>
        <div class="dw-stat-tile-value">
          {{ totals.sms_unit_cnt }}
          <small>({{ (totals.sms_unit_cnt / totals.sms_cnt) | roundNumber(1) }}/msg)</small>
        </div>
      </div>
      <div v-if="totals.sms_cost > 0" class="dw-stat-tile">
        <div class="dw-stat-tile-label">Sent Cost</div>
        <div class="dw-stat-tile-value">
          ${{ totals.sms_cost }}
          <small>(${{ (totals.sms_cost / totals.sms_cnt) | roundNumber(3) }}/msg)</small>
        </div>
      </div>
      <div v-if="totals.sms_inbound_cnt > 0" class="dw-stat-tile">
        <div class="dw-stat-tile-label">Received Count</div>
        <div class="dw-stat-tile-value">{{ totals.sms_inbound_cnt }}</div>
      </div>
      <div v-if="totals.sms_inbound_cnt > 0" class="dw-stat-tile">
        <div class="dw-stat-tile-label">Received Cost</div>
        <div class="dw-stat-tile-value">${{ totals.sms_inbound_cost }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'widget_sms_stats',
  props: {
    totals: { type: Object, default: null },
    loading: { type: Boolean, default: false },
  },
}
</script>
